export enum Launch_Quick_Spin {
  pt = "pt",
  es = "es",
  hu = "hu",
}
